import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, View, SafeAreaView, ActivityIndicator } from 'react-native';
// @ts-ignore
import awsconfig from './src/aws-exports';
import Amplify, { Auth } from 'aws-amplify';
import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components';
import * as AppConst from './src/components/AppConst';
import * as CmnUtil from './src/components/CmnUtil';
import Login from './src/screen/login/Login';
import AppMain from './src/screen/AppMain';

/** ================================
*  全体画面
*  ================================*/
Amplify.configure(awsconfig);

const App = () => {
  // cognitoユーザー
  const [authState, setAuthState] = useState<any>(undefined);

  // 処理中
  const [loading, setLoading] = useState(false);
  CmnUtil.setLoadingFunc(setLoading);

  useEffect(() => {
    return onAuthUIStateChange((nextAuthState, authData) => {
      if (nextAuthState === AuthState.SignedIn && authData) {
        // 管理者グループに所属する場合のみサインインを許可する
        (async () => {
          const currentSession = await Auth.currentSession();
          const { payload } = currentSession.getIdToken();
          if (payload && payload['cognito:groups']) {
            for (const group of payload['cognito:groups']) {
              if (group === AppConst.cognitoGroup.admins || group === 'Administrator') {
                setAuthState(nextAuthState);
                return;
              }
            }
          }
          setAuthState(undefined);
          CmnUtil.appAlert('管理権限がありません。');
          Auth.signOut();
        })();
      } else {
        setAuthState(nextAuthState);
      }
    });
  }, []);

  return (
    <SafeAreaView style={styles.container}>
      {/* メイン画面 */}
      <View style={styles.appHeader}>
        <Text style={[AppConst.styles.fontSizeLL, { color: AppConst.defaultTextColor }]} numberOfLines={1}>
          梨生産者・普及指導員コミュニケーションアプリ 管理システム
        </Text>
      </View>
      <View style={styles.appBody}>
        {authState === AuthState.SignedIn ? <AppMain /> : <Login />}
      </View>

      {/* ローディング */}
      {loading && <View style={AppConst.styles.loading}>
        <ActivityIndicator
          animating={true}
          color={AppConst.defaultColor}
          size='large' />
      </View>}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  appHeader: {
    backgroundColor: AppConst.defaultColor,
    height: AppConst.headerHeight,
    alignItems: 'center',
    justifyContent: 'center',
  },
  appBody: {
    flex: 1,
  },
});

export default App;
